import { WhichWeightAPI } from 'WhichWeightAPI'
import { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext } from '../ModalContext'
import { GetCoachRoleOptions } from 'functions/roleBasedAccessUtils'

import OutlineButton from 'components/Buttons/OutlineButton'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function AssignRoleModal() {

    const { modalData, HideModal } = useContext(ModalContext)
    
    const userId = useSelector((state) => state.user.id)
    const organizationId = useSelector(state => state.user.organizationId);
    const userType = useSelector((state) => state.user.type)
    
    const [selectedRole, setSelectedRole] = useState(modalData.coach.type)
    const [isLoading, setIsLoading] = useState(false)
    const [errorText, setErrorText] = useState('')

    const OnSaveChanges = async () => {
        if (selectedRole === '') {
            setErrorText('Please select a role')
            return
        }

        setErrorText('')
        setIsLoading(true)

        try {
            const jsonBody = {
                organizationId: organizationId, // sending for authorizer
                requestingUserId: userId,
                userId: modalData.coach.id,
                role: selectedRole
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI('CORE', 'POST', '/update_role', jsonBody)

            // console.log(result)

            if (result.data.status === 'failure') {
                setErrorText('Failed to update role. Please try again.')
                setIsLoading(false)
                console.error(result)
                return
            }

            setIsLoading(false)

            window.location.reload()
            
        } catch (error) {
            setErrorText('Failed to update role. Please try again.')
            setIsLoading(false)
            console.error('Error updating role:', error)
            return
        }
    }

    return (
        <div className="space-y-4">
            <div className='-mt-5 space-y-2'>
                <div className="text-left text-base font-semibold leading-6 text-gray-900">
                    Change role for {modalData.coach.firstName} {modalData.coach.lastName}
                </div>

                <p className='text-xs text-left text-gray-500'>
                    Updating a role for a coach changes how they will be able to access data within your organization.
                    See details below for more information on each role.
                </p>
            </div>

            <div className='border border-gray-400 divide-y divide-gray-400 rounded-lg overflow-hidden'>
                {GetCoachRoleOptions(userType).map((option, index) => (
                    <div 
                        key={index}
                        className='p-4 flex items-center cursor-pointer hover:bg-gray-100'
                        onClick={() => setSelectedRole(option.key)}
                    >
                        <div className='flex-1 space-y-1'>
                            <div className='text-left text-base text-gray-700'>{option.label}</div>
                            <div className='text-left text-xs text-gray-500'>{option.description}</div>
                        </div>

                        {option.key === selectedRole && <div className='w-5 h-5 border border-orange-200 bg-orange-400 rounded-full' />}
                        {option.key !== selectedRole && <div className='w-5 h-5 border border-gray-400 rounded-full' />}
                    </div>
                ))}
            </div>

            {errorText !== '' && (
                <div className="text-red-500 text-sm text-center">{errorText}</div>
            )}

            <div className='flex items-center gap-x-4'>
                <div className='flex-1'>
                    <OutlineButton
                        text="Cancel"
                        className='hover:bg-gray-50'
                        action={HideModal}
                    />
                </div>

                <div className='flex-1'>
                    <BrandColorButton
                        text="Save Changes"
                        action={OnSaveChanges}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    )
}
